import { render, staticRenderFns } from "./AdminStats.vue?vue&type=template&id=4e85d163&"
import script from "./AdminStats.vue?vue&type=script&lang=js&"
export * from "./AdminStats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports